export default __webpack_public_path__ + "static/media/walletconnect.0037fd90.svg";